import React from 'react';
import ResultValue from '../../Simple/ResultValue';

export default function Comorbidities(props) {  
    const fy = getFiscalYear(props.result.toDate);

    return (<>
        <h4>Comorbidities</h4>

        {props.result.comorbDevelDisab === "Y" && <ResultValue label="Developmental Disabilities" />}
        {props.result.comorbCoaguDefic === "Y" && <ResultValue label="Coagulation Factor Deficit" />}
        {props.result.comorbTrach === "Y" && <ResultValue label="Tracheostomy" />}
        {props.result.comorbRenalAcute === "Y" && <ResultValue label="Renal Failure, Acute" />}
        {props.result.comorbRenalChronic === "Y" && <ResultValue label="Renal Failure, Chronic" />}
        {props.result.comorbOncol === "Y" && <ResultValue label="Oncology Treatment" />}
        {props.result.comorbUncontDM === "Y" && <ResultValue label="Uncontrolled Diabetes Mellitus" />}
        {props.result.comorbProteinMalnut === "Y" && <ResultValue label="Severe Protein Malnutrition" />}
        {props.result.comorbEatingDisorder === "Y" && <ResultValue label="Eating and Conduct Disorders" />}
        {props.result.comorbInfectiousDisease === "Y" && <ResultValue label="Infectious Diseases" />}
        {fy >= 2025 ? (
                props.result.comorbDrugAlchMental === "Y" && <ResultValue label="Intensive Management for High-Risk Behavior" />
            ) : (
                props.result.comorbDrugAlchMental === "Y" && <ResultValue label="Drug/Alcohol Induced Mental Disorders" />
            )}
        {props.result.comorbCardiac === "Y" && <ResultValue label="Cardiac Conditions" />}
        {props.result.comorbGangrene === "Y" && <ResultValue label="Gangrene" />}
        {fy >= 2025 ? (
                props.result.comorbCOPD === "Y" && <ResultValue label="Chronic Obstructive Pulmonary Disease and Sleep Apnea" />
            ) : (
                props.result.comorbCOPD === "Y" && <ResultValue label="Chronic Obstructive Pulmonary Disease" />
            )}
        {props.result.comorbArtificialOpenings === "Y" && <ResultValue label="Artificial Openings - Digestive &amp; Urinary" />}
        {props.result.comorbPoisoning === "Y" && <ResultValue label="Poisoning" />}
        {props.result.comorbMusculoskeletal === "Y" && <ResultValue label="Severe Musculoskeletal &amp; Connective Tissue Diseases" />}
    </>);
}

function getFiscalYear(dateString) {
    const date = new Date(dateString);
    const month = date.getUTCMonth()+1;
    const year = date.getUTCFullYear();
    
    if (month >= 10) {
        return year + 1;
    } else {
        return year;
    }
}